import { useContext, useState } from 'react';
import ChallengeContext from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeContext';
import useApi from '@/lib/api/useApi';
import useAddCopySuffix from '@/lib/utils/useAddCopySuffix';
import TaskContext from '../../TaskContext';
import { type TaskSummary } from '@/lib/types';
import NewlySharedContext from '@/components/ChallengePortfolio/NormalView/NewlySharedChallenges/NewlySharedContext';
import ChallengePortfolioContext from '@/components/ChallengePortfolio/ChallengePortfolioContext';
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  type MenuItemProps,
} from '@mui/material';
import { FileCopyOutlined as CopyIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import MenuItemLoadingIndicator from '@/components/Menu/MenuItemLoadingIndicator';
import RequestPortfolioItemCloseContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemViewCardWithPageOverlay/ClosablePageOverlay/RequestPortfolioItemCloseContext';

type CopyTaskProps = Omit<MenuItemProps, 'onClick' | 'disabled' | 'children'>;

const CopyTask = (props: CopyTaskProps) => {
  const api = useApi();

  const [isNewlyShared, , setNewlySharedChallenges] =
    useContext(NewlySharedContext);
  const [, setChallengePortfolio] = useContext(ChallengePortfolioContext);
  const [challenge, setChallenge] = useContext(ChallengeContext);
  const [task] = useContext(TaskContext);

  const [copying, setCopying] = useState(false);

  const addCopySuffix = useAddCopySuffix();
  const requestTaskClose = useContext(RequestPortfolioItemCloseContext);

  const copyTask = async (): Promise<void> => {
    setCopying(true);

    const taskCopy = await api.post<TaskSummary>(
      `challenge-portfolio/tasks/${task.id}/copy`,
      {
        name: addCopySuffix(task.name),
      },
    );

    setChallenge(challenge => {
      challenge.tasks[taskCopy.id] = taskCopy;
    });

    if (isNewlyShared) {
      setNewlySharedChallenges(newlySharedChallenges => {
        (newlySharedChallenges[challenge.id].tasks as TaskSummary[]).push(
          taskCopy,
        );
      });
    } else {
      setChallengePortfolio(challengePortfolio => {
        (
          challengePortfolio.challenges[challenge.id].tasks as TaskSummary[]
        ).push(taskCopy);
      });
    }

    setCopying(false);
    requestTaskClose();
  };

  return (
    <MenuItem onClick={copyTask} disabled={copying} {...props}>
      <ListItemIcon>
        {copying ? <MenuItemLoadingIndicator /> : <CopyIcon />}
      </ListItemIcon>
      <ListItemText>
        <FormattedMessage id="portfolio.challenge.options.copy.label.as_task" />
      </ListItemText>
    </MenuItem>
  );
};

export default CopyTask;
